import { UseExternalRPCQueryOptions, useRPCQuery } from '@/lib/api/request/use-rpc-query';

type GetBonusesByUserIdRequest = Record<string, never>;

type GetBonusesByUserIdResponse = {
  bonuses: number;
  hasBonusConsent?: boolean;
};

export function useGetBonusesByUserId({
  params,
  ...opts
}: UseExternalRPCQueryOptions<GetBonusesByUserIdResponse, GetBonusesByUserIdRequest>) {
  return useRPCQuery({
    ...opts,
    queryKey: ['ignoreLoading'],
    method: useGetBonusesByUserId.method,
    params,
  });
}

useGetBonusesByUserId.method = 'bonuses:get-bonuses-by-user-id';
